import { FC, ReactNode } from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { useHoverPopover } from 'shared/hooks/useHoverPopover';
import { TextColor } from 'shared/theme/colors';
import { Col } from '../Col';
import { NoteIcon } from '../Icons';
import { Row } from '../Row';
import { Spinner } from '../Spinner';

type AnalyticsBlockCardProps = {
  title: string;
  afterTitleSpacing?: number;
  children?: ReactNode;
  height?: number | string;
  tooltipText?: ReactNode;
  tooltipWidth?: number;
  isLoading?: boolean;
};

export const AnalyticsBlockCard: FC<AnalyticsBlockCardProps> = ({
  title,
  afterTitleSpacing = 9,
  children,
  height,
  tooltipText,
  tooltipWidth,
  isLoading,
}) => {
  const popoverContent = (
    <Typography
      variant="paragraphS"
      color={TextColor.Primary}
      sx={{ m: 6, width: tooltipWidth }}
    >
      {tooltipText}
    </Typography>
  );
  const tooltipIcon = <NoteIcon />;

  const { HoverPopoverComponent: TooltipComponent } = useHoverPopover({
    popoverContent,
    popoverAnchorElement: tooltipIcon,
  });

  return (
    <Card sx={{ height: height, position: 'relative' }}>
      <CardContent
        sx={{
          '&.MuiCardContent-root': {
            py: 9,
          },
          px: 8,
        }}
      >
        <Col spacing={afterTitleSpacing}>
          <Row spacing={5}>
            <Typography variant="headerXS">{title}</Typography>
            {tooltipText && <TooltipComponent />}
          </Row>
          {children}
        </Col>
      </CardContent>

      {isLoading && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            zIndex: 10,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spinner />
        </Box>
      )}
    </Card>
  );
};
